import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Image from 'common/image'
import QuickLinkArrow from 'assets/quicklink-arrow.svg'
import { adobeInteractionEvent } from 'utils/adobewa'

const QuicklinksContainer = styled.div`
    width: 100%;
    height: 592px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 80px;
    background-color: #fafafa;
`
const TitleText = styled.div`
    color: #121b21;
    text-align: center;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 60px; /* 125% */
`

const QuickLinksSection = styled.div`
    width: 1162px;
    padding-top: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
`

const QuickSectionItemRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 40px;
`

const QuickLinkItem = styled.div`
    display: flex;
    width: 560px;
    height: 160px;
    padding: 28px 24px 28px 28px;
    align-items: flex-start;
    flex-shrink: 0;
    border-radius: 0 0 25px 25px;
    border-top: 2px solid #c5924d;
    background: #fff;
    box-shadow: 1px 6px 14px 0 rgba(0, 0, 0, 0.05);
`

const QuickLinkItemLeft = styled.div`
    width: 470px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
`

const QuickLinkTitle = styled.div`
    color: #606060;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 175% */
`

const QuickLinkDescription = styled.div`
    color: #121b21;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const QuickLinkItemRight = styled.div`
    display: flex;
    height: 96px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`

export default function QuickLinks() {
    const { t, i18n } = useTranslation('', { keyPrefix: 'Quicklinks' })
    const lang = i18n.language

    const quickLinkClick = (targetUrl: string) => {
        adobeInteractionEvent({
            lang: lang,
            eventID: 'prioritysite_click_Page_Quick-Link',
            contentUrl: targetUrl,
        })
        window.open(targetUrl, '_blank')
    }

    return (
        <QuicklinksContainer>
            <TitleText>{t('QuickLinks')}</TitleText>
            <QuickLinksSection>
                <QuickSectionItemRow>
                    <QuickLinkItem>
                        <QuickLinkItemLeft>
                            <QuickLinkTitle>
                                {t('quicklinktitle1')}
                            </QuickLinkTitle>
                            <QuickLinkDescription>
                                {t('quinklinkcontent1')}
                            </QuickLinkDescription>
                        </QuickLinkItemLeft>
                        <QuickLinkItemRight
                            onClick={() => {
                                quickLinkClick(t('quinklinkurl1'))
                            }}
                        >
                            <Image
                                src={QuickLinkArrow}
                                width={24}
                                height={24}
                                alt="quick link arrow"
                            />
                        </QuickLinkItemRight>
                    </QuickLinkItem>
                    <QuickLinkItem>
                        <QuickLinkItemLeft>
                            <QuickLinkTitle>
                                {t('quicklinktitle2')}
                            </QuickLinkTitle>
                            <QuickLinkDescription>
                                {t('quinklinkcontent2')}
                            </QuickLinkDescription>
                        </QuickLinkItemLeft>
                        <QuickLinkItemRight
                            onClick={() => {
                                quickLinkClick(t('quinklinkurl2'))
                            }}
                        >
                            <Image
                                src={QuickLinkArrow}
                                width={24}
                                height={24}
                                alt="quick link arrow"
                            />
                        </QuickLinkItemRight>
                    </QuickLinkItem>
                </QuickSectionItemRow>
                <QuickSectionItemRow>
                    <QuickLinkItem>
                        <QuickLinkItemLeft>
                            <QuickLinkTitle>
                                {t('quicklinktitle3')}
                            </QuickLinkTitle>
                            <QuickLinkDescription>
                                {t('quinklinkcontent3')}
                            </QuickLinkDescription>
                        </QuickLinkItemLeft>
                        <QuickLinkItemRight
                            onClick={() => {
                                quickLinkClick(t('quinklinkurl3'))
                            }}
                        >
                            <Image
                                src={QuickLinkArrow}
                                width={24}
                                height={24}
                                alt="quick link arrow"
                            />
                        </QuickLinkItemRight>
                    </QuickLinkItem>
                    <QuickLinkItem>
                        <QuickLinkItemLeft>
                            <QuickLinkTitle>
                                {t('quicklinktitle4')}
                            </QuickLinkTitle>
                            <QuickLinkDescription>
                                {t('quinklinkcontent4')}
                            </QuickLinkDescription>
                        </QuickLinkItemLeft>
                        <QuickLinkItemRight
                            onClick={() => {
                                quickLinkClick(t('quinklinkurl4'))
                            }}
                        >
                            <Image
                                src={QuickLinkArrow}
                                width={24}
                                height={24}
                                alt="quick link arrow"
                            />
                        </QuickLinkItemRight>
                    </QuickLinkItem>
                </QuickSectionItemRow>
            </QuickLinksSection>
        </QuicklinksContainer>
    )
}
